import { render, staticRenderFns } from "./StadiumAdminSettingCreateAndUpdateFormItems.vue?vue&type=template&id=5ec12f96&"
import script from "./StadiumAdminSettingCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumAdminSettingCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec12f96')) {
      api.createRecord('5ec12f96', component.options)
    } else {
      api.reload('5ec12f96', component.options)
    }
    module.hot.accept("./StadiumAdminSettingCreateAndUpdateFormItems.vue?vue&type=template&id=5ec12f96&", function () {
      api.rerender('5ec12f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumAdminSettingCreateAndUpdateFormItems.vue"
export default component.exports